import httpClient from "@utils/httpClient";

/**
 * Get all users (filtered for HR and Program Manager only)
 */
export const getAllUsers = async () => {
  try {
    const response = await httpClient.get('/users');

    return {
      success: response.success,
      data: response.users || [],
      error: response.error
    };
  } catch (error) {
    console.error('getAllUsers error:', error);
    return {
      success: false,
      data: [],
      error: { message: error.message }
    };
  }
};

/**
 * Get all roles
 */
export const getAllRoles = async () => {
  try {
    const response = await httpClient.get('/roles');

    return {
      success: response.success,
      data: response.roles || [],
      error: response.error
    };
  } catch (error) {
    console.error('getAllRoles error:', error);
    return {
      success: false,
      data: [],
      error: { message: error.message }
    };
  }
};

/**
 * Create a new user
 */
export const createUser = async (userData) => {
  try {
    const response = await httpClient.post('/users', userData);

    return {
      success: response.success,
      data: response.user || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('createUser error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to create user' }
    };
  }
};

/**
 * Update an existing user
 */
export const updateUser = async (userId, userData) => {
  try {
    const response = await httpClient.put(`/users/${userId}`, userData);

    return {
      success: response.success,
      data: response.user || null,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('updateUser error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to update user' }
    };
  }
};

/**
 * Delete a user
 */
export const deleteUser = async (userId) => {
  try {
    const response = await httpClient.delete(`/users/${userId}`);

    return {
      success: response.success,
      message: response.message,
      error: response.error
    };
  } catch (error) {
    console.error('deleteUser error:', error);
    return {
      success: false,
      error: { message: error.message || 'Failed to delete user' }
    };
  }
};

/**
 * Get dashboard statistics
 */
export const getDashboardStats = async () => {
  try {
    const response = await httpClient.get('/users');

    if (response.success) {
      const users = response.users || [];
      const hrCount = users.filter(u => u.role_name === 'HR').length;
      const pmCount = users.filter(u => u.role_name === 'Program Manager').length;

      return {
        success: true,
        data: {
          totalHR: hrCount,
          totalProgramManagers: pmCount,
          totalUsers: hrCount + pmCount
        },
        error: null
      };
    } else {
      return {
        success: false,
        data: null,
        error: response.error
      };
    }
  } catch (error) {
    console.error('getDashboardStats error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};
